/* eslint-disable*/
const formateRadio = schema => {
  const {
    properties: { options }
  } = schema;
  const fixOptions =
    options &&
    options.map(i => {
      return i.dict_id
        ? {
            label: i.option,
            value: i.value,
            hasDynamic: !!(i.mounts && i.mounts.length > 0),
            dynamic: i.mounts || [],
            dict_id: i.dict_id
          }
        : {
            label: i.option,
            value: i.value,
            hasDynamic: !!(i.mounts && i.mounts.length > 0),
            dynamic: i.mounts || []
          };
    });
  const fixProperties = Object.assign({}, schema.properties, {
    options: fixOptions
  });
  return {
    id: schema.id,
    type: 'radio',
    modelKey: schema.key,
    valueType: schema.value_type,
    label: schema.name,
    properties: fixProperties,
    rule: {
      required: schema.required
    },
    messages: {},
    value: schema.value
  };
};

const formateTextarea = schema => {
  const {
    properties: { rule }
  } = schema;
  return {
    id: schema.id,
    type: 'textarea',
    modelKey: schema.key,
    valueType: schema.value_type,
    label: schema.properties.title,
    properties: schema.properties,
    rule: {
      type: 'string',
      required: schema.required,
      placeholder: schema.properties.placeholder
        ? schema.properties.placeholder
        : '请在这里输入',
      custom: val => {
        if (schema.required) {
          return (
            val && val.length >= rule.min_len && val.length <= rule.max_len
          );
        } else {
          return true;
        }
      }
    },
    messages: {
      custom:
        rule && rule.tips && rule.tips.invalid
          ? rule.tips.invalid
          : '请描述您遇到的情况，以便小滴为您核实处理'
    },
    value: schema.value
  };
};

const formateText = schema => {
  return {
    id: schema.id,
    type: 'text',
    modelKey: schema.key,
    valueType: schema.value_type,
    label: schema.name,
    properties: schema.properties,
    rule: {},
    message: {},
    value: schema.value
  };
};

const formateMap = schema => {
  return {
    id: schema.id,
    type: 'map',
    modelKey: schema.key,
    valueType: schema.value_type,
    label: schema.name,
    properties: schema.properties,
    value: schema.value
  };
};

const formateStaticQuestionList = schema => {
  return {
    id: schema.id,
    type: 'static_question_list',
    modelKey: schema.key,
    valueType: schema.value_type,
    label: schema.name,
    properties: schema.properties,
    value: schema.value,
    rule: {
      required: schema.required
    },
    messages: {
      custom: '此为必填项'
    }
  };
};

const formateConfirmDialog = schema => {
  return {
    id: schema.id,
    type: 'confirm',
    modelKey: schema.key,
    valueType: schema.value_type,
    label: schema.name,
    properties: schema.properties,
    value: schema.value,
    rule: {
      required: schema.required
    }
  };
};

const formateAuthorizeVideo = schema => {
  return {
    id: schema.id,
    type: 'media_auth',
    modelKey: schema.key,
    valueType: schema.value_type,
    label: schema.name,
    properties: schema.properties,
    rule: {
      required: !!schema.required
    },
    value: schema.value
  };
};

const formateSchemaBill = (schema, info) => {
  const {
    properties: { rule }
  } = schema;
  const k = schema.properties.desc;
  const j = k.replace(/({)|(})/g, '');
  const target = info ? info.filter(i => i.key === j)[0] : null;
  const needCheck = !!schema.required;
  return {
    id: schema.id,
    type: 'protocol_checkbox',
    modelKey: schema.key,
    valueType: schema.value_type,
    label: target ? target.value : j,
    properties: schema.properties,
    rule: {
      required: needCheck,
      custom: val => {
        // 如果是required，就是返回checkbox情况，如果不需要require直接返回true
        if (needCheck) {
          return val;
        } else {
          return true;
        }
      }
    },
    messages: {
      custom:
        rule && rule.tips && rule.tips.invalid
          ? rule.tips.invalid
          : '请勾选同意后再提交'
    },
    value: !!schema.value
  };
};

const formateCollapse = schema => {
  return {
    id: schema.id,
    type: 'collapse',
    modelKey: schema.key,
    valueType: schema.value_type,
    label: schema.name,
    properties: schema.properties,
    rule: {},
    message: {},
    value: schema.value
  };
};

const formateButton = schema => {
  const {
    properties: { theme }
  } = schema;
  const themeMap = {
    orange: {
      outline: false,
      light: false,
      primary: true
    },
    light: {
      outline: true,
      light: true,
      primary: false
    },
    dark: {
      outline: false,
      light: false,
      primary: false
    }
  };
  return {
    id: schema.id,
    modelKey: schema.key,
    valueType: schema.value_type,
    name: schema.name,
    required: schema.required,
    value: schema.value,
    type: 'button',
    theme: themeMap[theme],
    properties: schema.properties
  };
};

const formatePopInfo = schema => {
  return {
    id: schema.id,
    modelKey: schema.key,
    valueType: schema.value_type,
    name: schema.name,
    required: schema.required,
    value: schema.value,
    type: 'pop_info',
    properties: schema.properties
  };
};

const formateProcessTag = schema => {
  let {
    properties: { theme }
  } = schema;
  if (!theme) {
    theme = 'green';
  }
  const themeMap = {
    green: {
      style: 'background: #ECF7F6'
    },
    red: {
      style: 'background: #E74C3C'
    },
    blue: {
      style: 'background: #3498DB'
    }
  };
  return {
    id: schema.id,
    modelKey: schema.key,
    valueType: schema.value_type,
    name: schema.name,
    type: 'process_tag',
    required: schema.required,
    value: schema.value,
    theme: themeMap[theme] || themeMap['green'],
    properties: schema.properties
  };
};

const formateQuestionList = schema => {
  return {
    id: schema.id,
    type: 'question_list',
    modelKey: schema.key,
    name: schema.name,
    properties: schema.properties,
    required: schema.required,
    valueType: schema.value_type,
    value: schema.value
  };
};

const formateQuestionListWithSug = schema => {
  return {
    id: schema.id,
    type: 'question_list_with_sug',
    modelKey: schema.key,
    name: schema.name,
    properties: schema.properties,
    required: schema.required,
    valueType: schema.value_type,
    value: schema.value
  };
};

const formateMessagePush = schema => {
  return {
    id: schema.id,
    type: 'message_push',
    modelKey: schema.key,
    name: schema.name,
    properties: schema.properties.data,
    required: schema.required,
    valueType: schema.value_type,
    value: schema.value
  };
};

const formateUploadImg = schema => {
  return {
    id: schema.id,
    type: 'upload_img',
    modelKey: schema.key,
    name: schema.name,
    properties: schema.properties,
    required: schema.required,
    valueType: schema.value_type,
    value: schema.value
  };
};

const formateBlacklistCheckbox = schema => {
  return {
    id: schema.id,
    type: 'blacklist_checkbox',
    modelKey: schema.key,
    name: schema.name,
    label: schema.properties.desc,
    required: schema.required,
    valueType: schema.value_type,
    value: !!schema.value
  };
};

const formateMultipleChoice = schema => {
  return {
    id: schema.id,
    type: 'multiple_choice_problem',
    modelKey: schema.key,
    name: schema.name,
    properties: schema.properties,
    required: schema.required,
    valueType: schema.value_type,
    value: schema.value
  };
};

const formateMultipleSelect = schema => {
  return {
    id: schema.id,
    type: 'collapse_mutli_select',
    modelKey: schema.key,
    name: schema.name,
    properties: schema.properties,
    required: schema.required,
    valueType: schema.value_type,
    value: schema.value
  };
};

const formateInputNumber = schema => {
  return {
    id: schema.id,
    type: 'number',
    modelKey: schema.key,
    valueType: schema.value_type,
    label: schema.name,
    properties: schema.properties,
    rule: {}
  };  
};

const formateDefineRadio = schema => {
  const {
    properties: { options }
  } = schema;
  const fixOptions =
    options &&
    options.map(i => {
      return i.dict_id
        ? {
            label: i.option,
            desc: i.desc,
            value: i.value,
            hasDynamic: !!(i.mounts && i.mounts.length > 0),
            dynamic: i.mounts || [],
            dict_id: i.dict_id
          }
        : {
            label: i.option,
            desc: i.desc,
            value: i.value,
            hasDynamic: !!(i.mounts && i.mounts.length > 0),
            dynamic: i.mounts || []
          };
    });
  const fixProperties = Object.assign({}, schema.properties, {
    options: fixOptions
  });
  return {
    id: schema.id,
    type: 'define_radio',
    modelKey: schema.key,
    valueType: schema.value_type,
    label: schema.name,
    properties: fixProperties,
    rule: {
      required: schema.required
    },
    messages: {},
    value: schema.value
  };
}
const formateSubmitKF = schema => {
  return {
    id: schema.id,
    type: 'submit_kf',
    modelKey: schema.key,
    valueType: schema.value_type,
    label: schema.name,
    properties: schema.properties,
    rule: {}
  };  
};

const formateRedirectInfo = schema => {
  return {
    id: schema.id,
    type: 'redirect_info',
    modelKey: schema.key,
    valueType: schema.value_type,
    label: schema.name,
    properties: schema.properties,
    rule: {}
  };  
};

const formateTabInfo = schema => {
  return {
    id: schema.id,
    type: 'tab',
    modelKey: schema.key,
    label: schema.name,
    properties: schema.properties,
    rule: {}
  };  
};

export const formateSchema = ({ type, payload, info }) => {
  switch (type) {
    case 'text':
      return formateText(payload);
      break;
    case 'radio':
      return formateRadio(payload);
      break;
    case 'textarea':
      return formateTextarea(payload);
      break;
    case 'media_auth':
      return formateAuthorizeVideo(payload);
      break;
    case 'protocol_checkbox':
      return formateSchemaBill(payload, info);
      break;
    case 'button':
      return formateButton(payload, info);
      break;
    case 'map':
      return formateMap(payload);
      break;
    case 'collapse':
      return formateCollapse(payload);
      break;
    case 'pop_info':
      return formatePopInfo(payload);
      break;
    case 'process_tag':
      return formateProcessTag(payload, info);
      break;
    case 'question_list':
      return formateQuestionList(payload);
      break;
    case 'question_list_with_sug':
      return formateQuestionListWithSug(payload);
      break;
    case 'message_push':
      return formateMessagePush(payload);
      break;
    case 'static_question_list':
      return formateStaticQuestionList(payload);
      break;
    case 'confirm':
      return formateConfirmDialog(payload);
    case 'upload_img':
      return formateUploadImg(payload);
    case 'blacklist_checkbox':
      return formateBlacklistCheckbox(payload);
    case 'multiple_choice_problem':
      return formateMultipleChoice(payload);
    case 'collapse_mutli_select':
      return formateMultipleSelect(payload);
    case 'input_number':
      return formateInputNumber(payload);
    case 'define_radio':
      return formateDefineRadio(payload);
    case 'submit_kf':
      return formateSubmitKF(payload);
    case 'redirect_info':
      return formateRedirectInfo(payload);
    case 'tab':
      return formateTabInfo(payload);
    default:
      break;
  }
};
